<template>
  <svg version="1.1" :width="width" :height="height" viewBox="0 0 24 24">
    <path
      :fill="color"
      d="M4,5A2,2 0 0,0 2,7V17A2,2 0 0,0 4,19H20A2,2 0 0,0 22,17V7A2,2 0 0,0 20,5H4M4,6H21V18H3V7M5,8V10H7V8H5M8,8V10H10V8H8M11,8V10H13V8H11M14,8V10H16V8H14M17,8V10H19V8H17M5,11V13H7V11H5M8,11V13H10V11H8M11,11V13H13V11H11M14,11V13H16V11H14M17,11V13H19V11H17M8,14V16H16V14H8Z"
    />
  </svg>
</template>

<script>
// @group Icons
// Keyboard icon
export default {
  name: "KeyboardIcon",
  props: {
    /** width in pixels */
    width: {
      type: Number,
      default: 24
    },
    /** height in pixels */
    height: {
      type: Number,
      default: 24
    },
    /** foreground color */
    color: {
      type: String,
      default: "white"
    }
  }
};
</script>
